import React from 'react';
import {
  CollectionFormModalContext,
} from '../../state/CollectionFormModalProvider';
import { CreateCollectionDialog } from '../CreateCollectionDialog';

const CollectionFormModalConsumer = () => (
  <CollectionFormModalContext.Consumer>
    {data => (
      <CreateCollectionDialog contextData={data} />
    )}
  </CollectionFormModalContext.Consumer>
);

export default CollectionFormModalConsumer;
